import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import styles from './Buttongroup.scss';

function buttongroupCenter({ text, items }) {
    return (<div className={styles['buttongroup-center']}>
        <span className={styles['buttongroup-text']}>
            {text}
        </span>
        <nav className={styles.buttongroup}>
            {items.map(({ title, content, onClick, isActive }) => (
                <a
                    role="presentation"
                    className={styles[`button-link-${isActive ? 'active' : 'normal'}`]}
                    title={title}
                    onClick={onClick}
                    key={title}
                >
                    {content}
                </a>
            ))}
        </nav>
    </div>)
}

buttongroupCenter.displayName = displayName('Buttons/ButtonGroup/ButtonGroupCenter');

buttongroupCenter.propTypes = {
    text: PropTypes.node.isRequired,
    items: PropTypes.array.isRequired,
};

export default buttongroupCenter;
